export default "__VITE_ASSET__993ef980__"